import Swiper, { Autoplay, EffectFade, Pagination, Navigation, Manipulation } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/**
 * スライダー関連
 */
export default class Slider {
  constructor() {
    this.homeSlider();
    this.topicsSlider();
  };

  /**
   * TOP メインスライダー
   */
  homeSlider() {
    if ($('.p-mainvisual__slider-container').length) {
      const swiper = new Swiper('.p-mainvisual__slider-container', {
        modules: [Autoplay, EffectFade],
        loop: true,
        speed: 500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 7000,
          disableOnInteraction: false,
        },
      });
    }
  };

  /**
   * TOPICS スライダー
   */
  topicsSlider() {
    if ( $('.c-topics__slider-container').length ) {
      // 出し分けするために削除するスライドを洗い出す
      let removeItems = [];
      let activeCategory = $('.c-topics__slider-container').data('type');
      if ( activeCategory != 'all' ) {
        $('.c-topics__slider-container .c-topics__slider-item').each(function (i) {
          if (activeCategory != $(this).data('category')) {
            removeItems.push(i);
          }
        });
      }

      const swiper = new Swiper('.c-topics__slider-container', {
        modules: [Autoplay, EffectFade, Pagination, Navigation, Manipulation],
        loop: true,
        speed: 500,
        slidesPerView: 'auto',
        centeredSlides: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.c-topics__slider-pagination',
        },
        navigation: {
          prevEl: '.c-topics__slider-prev',
          nextEl: '.c-topics__slider-next'
        }
      });
      swiper.removeSlide(removeItems); // 該当のカテゴリー以外のスライドを削除
    }
  };
}
